import styled from 'styled-components';

export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
`;

export const FilterWrapper = styled.div`
	margin: 0 20px 0 0;
`;

export const ContentDiv = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;
